_ = require('lodash')
RecommendModal = require('../components/modal/recommend-pc-modal.jade')
RecommendModalCtrl = require('../components/modal/recommend-modal-controller.coffee')

ScoreRegistrationCtrl = ($scope, $location, $filter, round, ownerPlayer, fromJapan, flash, RoundAPIService, ScoreDataHolderService, ScoreUploadHelperService, AccordionStateHolderService, $analytics, $modal) ->

  $analytics.eventTrack('ETR_loaded')

  if round and round.agency_request_id
    flash.error $filter('translate')('AGENCY_DENINED')
    return $location.path '/'

  ScoreDataHolderService.init(round, ownerPlayer, fromJapan)
  AccordionStateHolderService.init(round)

  $scope.scoreHolder = ScoreDataHolderService
  $scope.accordionStateHolder = AccordionStateHolderService
  $scope.isSubmitting = false

  if window.innerWidth < 768
    $modal.open
      size: 'sm'
      template: RecommendModal
      controller: RecommendModalCtrl

  $scope.canSubmit = ->
    ScoreDataHolderService.club and ScoreDataHolderService.roundInfo and ScoreDataHolderService.players

  $scope.submit = ->
    $scope.isSubmitting = true
    params = ScoreUploadHelperService.createParams(
      ScoreDataHolderService.roundInfo,
      ScoreDataHolderService.club,
      ScoreDataHolderService.players
    )

    RoundAPIService.uploadScore(params).then ->
      flash.success $filter('translate')('API_SUCCESS')
      $location.path('/')
    , ->
      flash.error $filter('translate')('API_ERROR')
    .finally ->
      $scope.isSubmitting = false

ScoreRegistrationCtrl.$inject = [
  '$scope'
  '$location'
  '$filter'
  'round'
  'ownerPlayer'
  'fromJapan'
  'flash'
  'RoundAPIService'
  'ScoreDataHolderService'
  'ScoreUploadHelperService'
  'AccordionStateHolderService'
  '$analytics'
  '$modal'
]

module.exports = ScoreRegistrationCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/score-registration/score-registration-controller.coffee